/// <reference path="../app.ts" />
namespace Cfnc {

    interface IcfncIncludeError extends ng.IDirective {

    }

    interface IcfncIncludeErrorScope extends ng.IScope {
        cfncIncludeError: any;
        errorModel: any;
    }

    class cfncIncludeError implements IcfncIncludeError {
        static directiveId: string = "cfncIncludeError";
        restrict: string = "A";
        require: string = "?ngModel";
        scope: any = {
            cfncIncludeError: "=cfncIncludeError",
            model: "=ngModel",
            errorModel: "=errorModel"
        }

        constructor(private $parse: ng.IParseService, private common: Cfnc.ICommonFactory) {
        }

        link = (scope: IcfncIncludeErrorScope, element, attrs, controller) => {
            //var cfncIncludeError: any = this.$parse(attrs.cfncIncludeError)(scope);
            var ctrl = controller;
            scope.$watch(() => { return scope.errorModel; } ,(errorModel) => {
                //var errorModel: any = this.$parse(attrs.cfncIncludeError)(scope);
                for (var key in errorModel) {
                    controller.$error[key] = errorModel[key];
                }
            });

            scope.$watch("model", (newValue, oldValue) => {
                console.log(newValue + ", " + oldValue);
                if (newValue != oldValue) {
                    for (var key in scope.cfncIncludeError) {
                        delete ctrl.$error[key];
                        delete scope.cfncIncludeError[key];
                        if (Object.keys(ctrl.$error).length <= 0) {
                            ctrl.$invalid = false;
                        }
                    }
                }
                
            });
        };
    }

    angular.module("app").directive(cfncIncludeError.directiveId, ["$parse", "common",
        ($parse: ng.IParseService, common: Cfnc.ICommonFactory) =>
            new cfncIncludeError($parse, common)
    ]);
}